import {map, tap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthService} from '../../services/auth.service';
import {UserInfo} from '../../types/user/user-info';
import {User, userFromBackendObject} from '../../types/user/user';
import {GenericApiResponse} from '../apibase.api';
import {BusinessTransaction, businessTransactionFromBackendObject} from '../../types/business-transaction';
import { HttpClient } from '@angular/common/http';
import {BlobId} from '@webmate-web-core/shared/types/ids';
import {ApiKey} from '@webmate-web-core/shared/types/user/apikey';
import {isDefined} from '@webmate-web-core/shared/utils/utils';

@Injectable({
    providedIn: 'root'
})
export class UserApi {

    constructor(public OAuth2AuthService: AuthService, private http: HttpClient) {
    }

    getUserInfo(userId: string): Observable<UserInfo> {
        return this.http.get<UserInfo>('/users/' + userId);
    }

    getUserInfosForProject(projectId: string): Observable<UserInfo[]> {
        return this.http.get<Array<any>>('/projects/' + projectId + '/users');
    }

    getUser(userId: string): Observable<User> {
        return this.http.get<any>('/users/' + userId + '/profile').pipe(map(response => userFromBackendObject(response)));
    }

    getCurrentUser(): Observable<User> {
        return this.http.get<any>('/users/current').pipe(map(response => userFromBackendObject(response)));
    }

    getLatestUserAction(userId: string): Observable<BusinessTransaction> {
        return this.http.get<any>('/users/' + userId + '/latest-action')
            .pipe(map(response => businessTransactionFromBackendObject(response)));
    }

    changeUserProperties(name: string, publicProperties: any, blobId?: BlobId, email?: string): Observable<GenericApiResponse> {
        let request = {
            newName: name,
            newPublicProperties: publicProperties,
            newAvatar: blobId,
            newEmail: email
        };
        return this.http.post<GenericApiResponse>('/users/change-user-properties', request);
    }

    changePassword(oldPassword: string, newPassword: string): Observable<GenericApiResponse> {
        let p = {
            'oldPassword': oldPassword,
            'newPassword': newPassword
        };
        return this.http.post<GenericApiResponse>('/users/change-password', p);
    }

    createNewApiKey(name: string): Observable<ApiKey> {
        return this.http.post<ApiKey>('/users/apikeys', {name: name});
    }

    getApiKeys(): Observable<ApiKey[]> {
        return this.http.get<ApiKey[]>('/users/apikeys');
    }

    deleteApiKey(id: string): Observable<GenericApiResponse> {
        return this.http.delete<GenericApiResponse>('/users/apikeys/' + id);
    }
}
